export function useSearchInput(val) {
  const reactiveValue = ref(val)
  const WoolSub1 = ref(val)
  const WoolSub2 = ref(val)
  const subOtherMaterialWool = ref(val)

  const emitInput = (emit, eventName) => {
    emit(eventName, reactiveValue.value, WoolSub1.value, WoolSub2.value, subOtherMaterialWool.value)
  }

  watch(() => reactiveValue.value , (newValue) => {
    reactiveValue.value = newValue
  })

  return {
    reactiveValue,
    WoolSub1,
    WoolSub2,
    subOtherMaterialWool,
    emitInput
  }
}

export function useEndsOption(isSearch) {
  const { t } = useI18n()
  const optionsEnds = ref([
    { value: '1', text: t('common.10561') },
    { value: '2', text: t('common.10562') },
    { value: '3', text: t('common.10563') }
  ])

  if (isSearch) {
    optionsEnds.value.unshift({ value: '0', text: t('common.10374') })
  }

  return { optionsEnds }
}

export function useMaterialInitValue() {
  const getMaterialInitValue = (basicLanguageOptions) => {
    return [
      {
        seq: -1,
        id: generateRandomeKey(6),
        composition: "",
        materialOption: "",
        materialDetailOption: "",
        materialWool: null,
        materialId: null,
        i18nMaterials: {
          i18ns: basicLanguageOptions.map(({ text, value }) => {
            return {
              locale: value,
              label: text,
              displayName: "",
              materialId: null,
              materialOption: "",
              materialDetailOption: "",
              new: true,
            }
          }),
        },
      },
    ]
  }
  return { getMaterialInitValue }
}
